<template lang="pug">
v-container(grid-list-md)
  v-layout(wrap, v-if="mutasi")
    v-flex(lg6, md6, xs12)
        v-layout(wrap)
            v-flex.subtitle-text.primary--text(lg3, md3, xs12) No. Rekening
            v-flex.subtitle-text.primary--text(lg9, md9, xs12) {{ mutasi.account | accountformat }}
            v-flex.subtitle-text.primary--text(lg3, md3, xs12) Periode
            v-flex.subtitle-text.primary--text(lg9, md9, xs12) {{ periode }}
    v-flex(lg3, md3, xs12)
      f-decimalbox(v-model="saldoAwal", readonly, label="Saldo Awal")
    v-flex(lg3, md3, xs12)
      f-decimalbox(v-model="saldoAkhir", readonly, label="Saldo Akhir")
    v-flex(lg12, md12, xs12, v-if="mutasi.details.length > 0")
      v-data-table(
        hide-default-footer,
        :headers="headers",
        :items="mutasiTransaction.details",
        :page.sync="page",
        :items-per-page="itemsPerPage",
        @page-count="pageCount = $event"
      )
        template(v-slot:item.transactionDateTime="{ item }")
          div {{ item.transactionDateTime | datetimeformat }}
        template(v-slot:item.settlementDate="{ item }")
          div {{ item.settlementDate | dateformat }}
        template(v-slot:item.amount="{ item }")
          div {{ item.amount | decimalformat }}
        template(v-slot:item.lastBalance="{ item }")
          div {{ item.lastBalance | decimalformat }}
      .text-xs-center.ma-2
        v-pagination(v-model="page", :length="pageCount")
</template>
<script>
export default {
  name: "FAccountStatementContent",
  props: ["mutasi", "account", "periode", "inquiryBalance", "byLimit"],
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      mutasiTransaction: {},
      headers: [
        {
          text: "Tanggal",
          value: "settlementDate",
          sortable: false,
          width: "100px",
          align: "center",
          class: "primary--text",
        },
        {
          text: "Timestamp",
          value: "transactionDateTime",
          sortable: false,
          width: "100px",
          align: "center",
          class: "primary--text",
        },
        {
          text: "Uraian Transaksi",
          value: "transactionMessage",
          sortable: false,
          class: "primary--text",
        },
        {
          text: "Tipe",
          align: "center",
          value: "dbCr",
          sortable: false,
          width: "50px",
          class: "primary--text",
        },
        {
          text: "Jumlah Pembayaran",
          align: "right",
          value: "amount",
          sortable: false,
          width: "120px",
          class: "primary--text",
        },
        {
          text: "Saldo",
          align: "right",
          value: "lastBalance",
          sortable: false,
          width: "130px",
          class: "primary--text",
        },
      ],
    };
  },
  watch: {
    mutasi(val) {
      this.page = 1;
      this.pageCount = 0;
      this.mutasiTransaction = val ? val : this.defaultMutasi();
      this.doCalculateLastAmountTx();
    },
  },
  mounted() {
    this.mutasiTransaction = this.mutasi ? this.mutasi : this.defaultMutasi();
    this.doCalculateLastAmountTx();
  },
  computed: {
    mutasiDebet() {
      if (this.mutasiTransaction.details) {
        return this.mutasiTransaction.details
          .filter((filter) => filter.dbCr === "DB")
          .map((map) => map.amount)
          .reduce((a, b) => a + b, 0);
      } else {
        return 0;
      }
    },
    mutasiCredit() {
      if (this.mutasiTransaction.details) {
        return this.mutasiTransaction.details
          .filter((filter) => filter.dbCr === "CR")
          .map((map) => map.amount)
          .reduce((a, b) => a + b, 0);
      } else {
        return 0;
      }
    },
    saldoAkhir() {
      return this.mutasi.lastBalance ? this.mutasi.lastBalance : 0;
    },
    saldoAwal() {
      return (
        this.mutasiTransaction.lastBalance -
        this.mutasiCredit +
        this.mutasiDebet
      );
    },
    notEffectiveBalance() {
      return 0;
    },
  },
  methods: {
    defaultMutasi() {
      this.mutasiTransaction = {
        prevBalance: 0,
        lastBalance: 0,
        details: [],
      };
    },
    doCalculateLastAmountTx() {
      if (this.byLimit) {
        let prevBalance = this.saldoAkhir;
        this.mutasiTransaction.details.forEach((m) => {
          m.lastBalance = prevBalance;
          if (m.dbCr === "DB") prevBalance += m.amount;
          else prevBalance -= m.amount;
        });
      } else {
        let prevBalance = this.saldoAwal;
        this.mutasiTransaction.details.forEach((m) => {
          if (m.dbCr === "DB") prevBalance -= m.amount;
          else prevBalance += m.amount;
          m.lastBalance = prevBalance;
        });
      }
    },
  },
};
</script>